import React from "react";
import { Link } from "react-router-dom";
import { Container } from "./ui/Container";
import knoothWordmark from "../assets/knooth_wordmark2.png";

const Footer = () => {
  return (
    <footer className="relative overflow-hidden bg-[#FBFBFD] text-[#2B00FF]">
      <div className="pointer-events-none absolute inset-0 z-0 flex justify-center">
        <div className="relative h-full w-full max-w-[1440px]">
          <div className="absolute -top-[300px] -left-[200px] h-[1000px] w-[1000px] rounded-full bg-[#FFCCE0] blur-[100px] opacity-90" />
          <div className="absolute -top-[300px] -right-[200px] h-[1000px] w-[1000px] rounded-full bg-[#FFEAC2] blur-[100px] opacity-90" />
        </div>
      </div>
      <Container className="relative z-10 pt-[80px] pb-[40px]">
        <div className="grid grid-cols-2 gap-x-[48px] gap-y-[48px] md:grid-cols-[1fr_auto_auto] md:gap-x-[204px] md:gap-y-0">
          <div className="col-span-2 row-start-1 md:col-span-1">
            <p className="text-[12px] font-semibold tracking-[0.12em] uppercase text-[#2B00FF]/50">Info</p>
          </div>

          <div className="col-start-1 row-start-2 md:col-auto md:row-auto">
            <p className="text-[12px] font-semibold tracking-[0.12em] uppercase text-[#2B00FF]/50">Product</p>
            <ul className="mt-[24px] space-y-[16px] text-[#2B00FF]">
              <li>
                <a href="#features" className="hover:text-[#2B00FF]/70 transition-colors">Features</a>
              </li>
              <li>
                <a href="#pricing" className="hover:text-[#2B00FF]/70 transition-colors">Pricing</a>
              </li>
            </ul>
          </div>

          <div className="col-start-2 row-start-2 justify-self-end text-right md:col-auto md:row-auto md:justify-self-end md:text-right">
            <p className="text-[12px] font-semibold tracking-[0.12em] uppercase text-[#2B00FF]/50">Support</p>
            <ul className="mt-[24px] space-y-[16px] text-[#2B00FF]">
              <li>
                <a href="#common-questions" className="hover:text-[#2B00FF]/70 transition-colors">Common questions</a>
              </li>
              <li>
                <Link to="/support#top" className="hover:text-[#2B00FF]/70 transition-colors">Contact us</Link>
              </li>
              <li>
                <Link to="/privacy-policy#top" className="hover:text-[#2B00FF]/70 transition-colors">Privacy policy</Link>
              </li>
              <li>
                <Link to="/terms-of-service#top" className="hover:text-[#2B00FF]/70 transition-colors">Terms of service</Link>
              </li>
            </ul>
          </div>
        </div>

        {/* <div className="mt-[80px] h-px bg-black/10 w-full" /> */}

        <div className="mt-[160px]">
          <img
            src={knoothWordmark}
            alt="knooth"
            width={2400}
            height={644}
            className="w-full h-auto select-none max-w-[520px] mx-auto md:max-w-none"
            draggable={false}
          />
        </div>

        <div className="mt-[24px] flex items-center justify-between gap-[16px] text-[#2B00FF] text-[14px]">
          <p>© {new Date().getFullYear()} knooth. All rights reserved.</p>
          <button
            type="button"
            className="hover:text-[#2B00FF]/70 transition-colors"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          >
            Back to top
          </button>
        </div>
      </Container>
    </footer>
  );
};

export { Footer };
